import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalActionsComponent } from '@app/components';
import { useTypedTranslation } from '@app/hooks';
import { getModalSwitch, getLoaderBtn, loadingData, handleGetOrganization } from '@app/store/actions';
import { organizationsService } from '@app/services';
import { genericErrorToast } from '@app/helpers';

export const ClearOrgLogoDialog = () => {
    const dispatch = useDispatch();
    const { translation } = useTypedTranslation();

    const thisOrganization: string = useSelector((state: any) => state.orgs.organization.Id);

    const handleCancel = () => {
        dispatch(getModalSwitch(false));
    };

    const handleClearOrgImage = () => {
        organizationsService.clearOrgLogo(thisOrganization, genericErrorToast, handleClearOrgImageSuccess);
    };

    const handleClearOrgImageSuccess = () => {
        dispatch(getModalSwitch(false));
        dispatch(getLoaderBtn(false));
        dispatch(handleGetOrganization(thisOrganization));
        dispatch(loadingData(false));
    };

    return (
        <>
            <p>{translation('ORG_CLEAR_LOGO_CONFIRM_BODY')}</p>
            <ModalActionsComponent
                primaryBtn={translation('OK')}
                secondaryBtn={translation('CANCEL')}
                onClickPrimary={handleClearOrgImage}
                onClickSecondary={handleCancel}
                disabled={false}
                id='clearImage'
            />
        </>
    );
};
